import { createAsyncThunk } from '@reduxjs/toolkit'

import { RootState } from '../../app/store'
import { postData } from '../../shared/api/api'
import {
  FetchSubwayDestinationsRequest,
  SubwayDestinationsResponse,
} from './types'

export const fetchDestinations = createAsyncThunk<
  SubwayDestinationsResponse,
  FetchSubwayDestinationsRequest,
  { state: RootState }
>('subway/fetchDestinations', async (request, thunkAPI) => {
  const { sceneId } = request
  const state = thunkAPI.getState()
  const { zone, user } = state
  const zoneId = zone?.data?.id

  if (!zoneId) {
    return thunkAPI.rejectWithValue(
      'Unable to fetch destinations. Missing zoneId from state.'
    )
  }

  const body = {
    userId: user?.profile?.uid,
    sceneId,
  }

  try {
    const response = await postData<SubwayDestinationsResponse>(
      `/zones/${zoneId}/subway/destinations`,
      body
    )
    return response
  } catch (error: any) {
    return thunkAPI.rejectWithValue(
      error?.response?.data?.error ||
        error.message ||
        'Failed to fetch destinations'
    )
  }
})
